import Vue from 'vue'

// axios
import axios from 'axios'

const axiosIns = axios.create({
  // You can add your headers here
  // ================================
  baseURL: process.env.VUE_APP_baseUrl,
  // timeout: 1000,
  // headers: {'X-Custom-Header': 'foobar'}
})

axiosIns.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token')
    const headers = { ...config.headers }

    if (token) {
      headers.Authorization = `Token ${token}`
    } else if (headers.Authorization) {
      delete headers.Authorization
    }

    return {
      ...config,
      headers,
    }
  },
  error => Promise.reject(error),
)

Vue.prototype.$http = axiosIns

export default axiosIns
